/* @flow */
import React from 'react';

import { retailLabel } from './messages';

// Component
import { PriceLabel } from './PriceLabel';

type RetailProps = {|
    currency: string,
    showLabel: boolean,
    price: number,
    quantityDisplay?: string,
    showPriceVariability: boolean,
|};

export function Retail({
    currency,
    price,
    showLabel,
    quantityDisplay,
    showPriceVariability,
}: RetailProps) {
    return (
        <PriceLabel
            price={price}
            label={showLabel ? retailLabel : ''}
            quantityDisplay={quantityDisplay}
            currency={currency}
            showPriceVariability={showPriceVariability}
        />
    );
}

Retail.defaultProps = {
    showLabel: false,
    showPriceVariability: false,
};
